import LayoutMain from './../../../../layouts/LayoutMain.vue';
import ProgressHUD from './../../../ProgressHUD/index.vue'
import GoogleMap from './../../../GoogleMap/VueGoogleMap.vue'
import LineChart from './LineChart.js'
import { Api, Toast, Helper } from './../../../../services'
import ModalDialogExistingProjectSendReport from './../../../Account/MyProfile/Widget/ModalDialogs/ModalDialogExistingProjectSendReport.vue'

export default {
  name: 'project',
  props: [],
  components: {
    LayoutMain,
    ProgressHUD,
    LineChart,
    ModalDialogExistingProjectSendReport,
    GoogleMap,
  },
  data() {
    return {
      data: null,
      balance: null,
      googleMap: {
        id: 'google-map',
        visible: true,
      },
      datacollection: {
        labels: [],
        actualData: [],
        predictedData: [],
      }, 
      typeChart: 'month', // two types: "week" or "month"
      userCountProject: 0,
      newPost: {
        id: 0,
        title: '',
        picture: null,
        description: '',
      },
      editPost: {
        id: 0,
        title: '',
        picture: null,
        description: '',
      },
      validationMessage: null,
      sumGGC: 0,
      sumGCC: 0,
      location: {},
      yearMwh: {"solar": 1500, "wind": 2400},
    }
  },
  filters: {
    filterDate(value) {
      if (value) {
        var monthNames = [
          'January',
          'February',
          'March',
          'April',
          'May',
          'June',
          'July',
          'August',
          'September',
          'October',
          'November',
          'December',
        ]
        var monthNamesShort = [
          'Jan',
          'Feb',
          'Mar',
          'Apr',
          'May',
          'Jun',
          'Jul',
          'Aug',
          'Sep',
          'Oct',
          'Nov',
          'Dec',
        ]

        var date = new Date(value),
          month = monthNamesShort[date.getMonth()],
          day = date.getDate(),
          year = date.getFullYear()

        if (month.length < 2) month = '0' + month
        if (day.length < 2) day = '0' + day

        return month + '. ' + day + ', ' + year
      }

      return ''
    },
  },
  methods: {
    payConsultingService() {
      alert('This feature is not yet implemented')
    },

    parseDate(input) {
      var parts = input.split('/')
      return new Date(parts[0], parts[1] - 1, parts[2])
    },

    isNullOrUndefined(value) {
      return value === null || value === undefined
    },

    // Events click on Tab
    weekChartClick(event) {
      // if value not changes
      if (this.typeChart == 'week') return

      this.typeChart = 'week'
      this.refreshDataForChart()
    },

    monthChartClick(event) {
      // if value not changes
      if (this.typeChart == 'month') return

      this.typeChart = 'month'
      this.refreshDataForChart()
    },

    // Display / refresh data for chart
    refreshDataForChart() {
      if (this.data.project == undefined || this.data.project == null) return

      // set data for charts
      this.datacollection.labels = []
      this.datacollection.actualData = []
      this.datacollection.predictedData = []

      var timeLine = 0
      if (this.typeChart == 'week') timeLine = 7
      else timeLine = 80

      var curentDate = new Date()
      var timePeriod = {
        first: new Date(
          curentDate.getFullYear(),
          curentDate.getMonth(),
          curentDate.getDate() - timeLine
        ),
        last: new Date(
          curentDate.getFullYear(),
          curentDate.getMonth(),
          curentDate.getDate()
        ),
      }

      // Get time period for filter
      for (var indexForIpvData in this.data.project.ipv) {
        var ipvDataByDay = this.data.project.ipv[indexForIpvData]
        if (!ipvDataByDay) {
          console.error('IPV Data is null')
          continue
        }

        var ivpDate = this.parseDate(ipvDataByDay.date)

        if (timePeriod.first <= ivpDate && ivpDate <= timePeriod.last) {
          this.datacollection.labels.push(ipvDataByDay.date)
          this.datacollection.actualData.push(ipvDataByDay.actual)
          this.datacollection.predictedData.push(ipvDataByDay.predict)
        }
      }
      console.log("this.datacollection>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>")
      console.log(this.datacollection)

      this.datacollection = this.createDataCollection(
        this.datacollection.labels,
        this.datacollection.actualData,
        this.datacollection.predictedData
      )
    },

    // Function for create data collection
    createDataCollection(labels, actualData, predictedData) {

      return {
        labels: labels,
        datasets: [
          {
            label: 'Actual',
            backgroundColor: 'rgba(91, 155, 213, 0.2)',
            borderColor: 'rgba(91, 155, 213, 1)',
            borderWidth: 1,
            data: actualData,
          },
          // {
          //   label: 'Predicted',
          //   backgroundColor: 'rgba(237, 125, 49, 0.2)',
          //   borderColor: 'rgba(237, 125, 49,1)',
          //   borderWidth: 1,
          //   data: predictedData,
          // },
        ],
      }
    },

    onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files
      if (!files) {
        this.newPost.picture = []
        return
      }

      this.newPost.picture = files
    },

    onFileChangeForEditPost(e) {
      var files = e.target.files || e.dataTransfer.files
      if (!files) {
        this.editPost.picture = []
        return
      }

      this.editPost.picture = files
    },

    goToEdit() {
      this.$router.push(
        '/project/systemsdetail/existing/edit/' + this.data.project._id
      )
    },

    async addNewPost() {
      try {
        const isValid = await this.$validator.validateAll('formNewPosts')
        if (!isValid) {
          Toast.validationFieldsError({
            toast: this.$toast,
          })

          return
        }

        this.$refs.progress.show()

        var formData = new FormData()
        formData.append('title', this.newPost.title)
        formData.append('text', this.newPost.description)
        formData.append('files0', this.newPost.picture[0])
        formData.append('project_id', this.data.project._id)

        var response = await Api.addPostToProject(formData)
        if (response.data) {
          // Add new post to list posts
          this.data.posts.push(response.data.post)

          // Set empty value in form for New Post
          this.newPost.id = 0
          this.newPost.title = ''
          this.newPost.description = ''
          this.newPost.picture = []

          this.$refs.Picture.value = ''
          this.$refs.Picture2.value = ''

          $('#modalAddPost').modal('close')
        } else {
          console.log(response.message)
          alert('Error: ' + response.message)
        }
      } catch (error) {
        this.validationMessage = 'Something went wrong.'

        Toast.error({
          toast: this.$toast,
          title: 'Error',
          message: 'Something went wrong.',
        })

        console.error(error)
      } finally {
        this.$refs.progress.hide()
      }
    },

    async saveEditPost() {
      try {
        const isValid = await this.$validator.validateAll('formEditPosts')
        if (!isValid) {
          Toast.validationFieldsError({
            toast: this.$toast,
          })

          return
        }

        this.$refs.progress.show()

        var formData = new FormData()
        formData.append('id', this.editPost.id)
        formData.append('title', this.editPost.title)
        formData.append('text', this.editPost.description)
        formData.append('project_id', this.editPost.project_id)

        if (this.editPost.picture && this.editPost.picture[0]) {
          formData.append('files0', this.editPost.picture[0])
        }

        var response = await Api.editPostInProject(formData)
        if (response.data) {
          // Edit post
          const post = this.data.posts.find(x => x._id === this.editPost.id)
          post.id = this.editPost._id
          post.title = this.editPost.title

          post.text = this.editPost.description
          post.project_id = this.editPost.project_id

          if (response.data.post.image && response.data.post.image.length > 0) {
            post.image = response.data.post.image
          }

          $('#modalEditPost').modal('close')
        } else {
          console.log(response.message)
          alert('Error: ' + response.message)
        }
      } catch (error) {
        this.validationMessage = 'Something went wrong.'

        Toast.error({
          toast: this.$toast,
          title: 'Error',
          message: 'Something went wrong.',
        })

        console.error(error)
      } finally {
        this.$refs.progress.hide()
      }
    },

    openDialogForEditPost(post) {
      this.editPost.id = post._id
      this.editPost.title = post.title
      this.editPost.picture = null
      this.editPost.description = post.text
      this.editPost.project_id = post.project_id

      this.$refs.editPicture.value = ''
      this.$refs.editPicture2.value = ''

      $('#modalEditPost input[name="Title"]')
        .siblings('label')
        .addClass('active')
      $('#modalEditPost textarea')
        .siblings('label')
        .addClass('active')

      $('#modalEditPost').modal('open')
    },

    async removePost(post) {
      try {
        this.$refs.progress.show()

        var response = await Api.removePostInProject(post._id)
        if (response.data) {
          this.removeElementInArray(this.data.posts, post)
        } else {
          console.log(response.message)
          alert('Error: ' + response.message)
        }
      } catch (error) {
        this.validationMessage = 'Something went wrong.'

        Toast.error({
          toast: this.$toast,
          title: 'Error',
          message: 'Something went wrong.',
        })

        console.error(error)
      } finally {
        this.$refs.progress.hide()
      }
    },

    removeElementInArray(array, element) {
      const index = array.indexOf(element)
      if (index !== -1) {
        array.splice(index, 1)
      }
    },

    openReport() {
      this.$refs.sendReport.openReport(this.data.project)
    },

    displayReportButton() {
      let date = new Date()
      return !(
        this.data.project.lastMonthlyReport &&
        this.data.project.lastMonthlyReport.month >= date.getMonth() - 1 &&
        this.data.project.lastMonthlyReport.year >= date.getFullYear()
      ) 
    },

    async getLatLongFrom(streetAddress, city, country) {
       try {
          var {
             data
          } = await axios.get(
             "https://maps.googleapis.com/maps/api/geocode/json?address=" +
             streetAddress + "+" + city + "+" + country + 
             "&key=AIzaSyDWz414jNEmGv-FDSbirtU-SSi1V0at2N4"
          );
          if (data.error_message) {
             console.log(data.error_message)
          } else {
             // this.address = data.results[0].formatted_address;
             this.location = data.results[0].geometry.location;
          }
       } catch (error) {
          console.log(error.message);
       }
    },
    async sendInfo(id) {
      try {
        var response = await Api.sendInfoProject(id)

        Toast.success({
            toast: this.$toast,
            message: "Project's info successfully sent on your email",
        })

      } catch (error) {
        console.log(error)
        Toast.error({
          toast: this.$toast,
          title: 'Error',
          message: 'Something went wrong.',
        })
      } finally {
      }
    }
  },
  async created() {
    try {
      var response = await Api.getSystemsDetailById(this.$route.params.id)
      this.data = response.data.results[0]
      console.log( "this.data ******* >>>>>>>>>>>>>>>>>" )
      console.log( this.data )
 
      this.sumGCC = this.$localStorage.get('GCC')
      this.sumGGC = this.$localStorage.get('GGC')

      var logos = {0:"solar", 1:"wind", 2:"gas", 3:"hydro"}, type = "", nameplateCapacity = 0, typeForLogo = "";          
      type = ((this.data.project.type.toLowerCase()).indexOf("wind")>-1) ? "wind" : "solar"
      nameplateCapacity = (this.data.project.capacitySize == "MW") ? this.data.project.nameplateCapacity : this.data.project.nameplateCapacity/1000
      this.data.project.sumYearMwh = this.yearMwh[type]*nameplateCapacity
      this.data.project.monthlyMwh = this.data.project.sumYearMwh/12
          for (var key in logos){           
            typeForLogo = this.data.project.type.toLowerCase()           
            if (typeForLogo.indexOf(logos[key])>-1) this.data.project.typeLogo = '/static/dist/images/' + logos[key] + '-black.svg';
          }

      await this.getLatLongFrom(this.data.project.streetAddress, this.data.project.city, this.data.project.country);     

      this.data.project.latitude = (this.data.project.latitude) ? this.data.project.latitude : this.location.lat
      this.data.project.longitude = (this.data.project.longitude) ? this.data.project.longitude : this.location.lng 

      await new Promise(resolve => this.$nextTick(resolve))

      this.$refs.googleMap.setPosition(
        this.data.project.latitude,
        this.data.project.longitude
      )
      this.refreshDataForChart()

      var response = await Api.getCountProjectsById(this.$route.params.id)
      this.userCountProject = response.data.results

      if (this.data.project.greenTokenWallet) {
        try {
          var response = await Api.getBalance(
            this.data.project.greenTokenWallet
          )
          this.balance = response.data.balance
        } catch (error) {
          this.balance = 'Wrong'
          console.error(error)
        }
      }
    } catch (error) {
      this.validationMessage = 'Something went wrong.'

      Toast.error({
        toast: this.$toast,
        title: 'Error',
        message: 'Something went wrong.',
      })

      console.error(error)
    } finally {
      this.$refs.progress.hide()
    }
  },
  mounted() {
    // Configuration materialize css
    var self = this
  },
}



// WEBPACK FOOTER //
// ./src/components/Project/SystemsDetail/ProjectExisting/ProjectExisting.component.js